<ion-header id="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">Close<ion-icon slot="start" name="close-circle-outline"></ion-icon></ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button (click)="save()"> Save<ion-icon slot="end" name="download-outline"></ion-icon> </ion-button>
    </ion-buttons>
    <ion-title>Affordability Report</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  @if (selectData$ | async; as data) {
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Affordability summary
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:py-2">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="12" size-md="5">
              <div class="tw:flex tw:items-center">
                <ion-icon
                  src="/assets/svg/monthly-payment.svg"
                  [ngClass]="['tw:text-5xl', 'tw:h-12', 'tw:w-12']"
                ></ion-icon>
                <div class="tw:ml-4">
                  <h2 class="tw:text-xs">You could afford a home up to:</h2>
                  <ion-text class="tw:text-base tw:font-bold tw:text-gray-800">
                    {{ data.purchasePrice | redCurrency: 0 : 2 }}
                  </ion-text>
                </div>
              </div>
              <hr class="tw:my-3 tw:border-gray-300" />
            </ion-col>
            <ion-col size="12" size-md="7">
              <red-chart [options]="chartOptions"></red-chart>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card-content>
    </ion-card>
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Summary
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:pb-2">
        <div class="tw:flex tw:bg-gray-100 tw:p-1">
          <ion-text class="tw:flex-auto">Purchase Price</ion-text>
          <ion-text>{{ data.purchasePrice | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:p-1">
          <ion-text class="tw:flex-auto">Down Payment</ion-text>
          <ion-text>{{ data.downPayment | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:bg-gray-100 tw:p-1">
          <ion-text class="tw:flex-auto">Mortgage Amount</ion-text>
          <ion-text>{{ data.mortgageAmount | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:p-1">
          <ion-text class="tw:flex-auto">Mortgage Term</ion-text>
          <ion-text>{{ data.mortgageTerm | redTime: 'year' }}</ion-text>
        </div>
        <div class="tw:flex tw:bg-gray-100 tw:p-1">
          <ion-text class="tw:flex-auto">Interest Rate</ion-text>
          <ion-text>{{ data.interestRate | redPercentage: 0 }}</ion-text>
        </div>
      </ion-card-content>
    </ion-card>
    <ion-card class="ion-no-margin tw:m-4">
      <ion-card-header class="ion-text-uppercase tw:px-2 tw:py-2 tw:text-xs tw:font-bold tw:text-gray-500">
        Payment Breakdown
      </ion-card-header>
      <ion-card-content class="tw:px-2 tw:pb-2">
        <div class="tw:flex tw:bg-gray-100 tw:p-1">
          <ion-text class="tw:flex-auto">Principal & Interest</ion-text>
          <ion-text>{{ data.principalAndInterest | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:p-1">
          <ion-text class="tw:flex-auto">Property Tax</ion-text>
          <ion-text>{{ data.propertyTax | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:bg-gray-100 tw:p-1">
          <ion-text class="tw:flex-auto">Monthly Homeowners Ins</ion-text>
          <ion-text>{{ data.monthlyHomeownersInsurance | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:p-1">
          <ion-text class="tw:flex-auto">Private Mortgage Insurance</ion-text>
          <ion-text>{{ data.privateMortgageInsurance | redCurrency: 0 : 2 }}</ion-text>
        </div>
        <div class="tw:flex tw:bg-gray-100 tw:p-1">
          <ion-text class="tw:flex-auto">Monthly Payment</ion-text>
          <ion-text>{{ data.monthlyPayment | redCurrency: 0 : 2 }}</ion-text>
        </div>
      </ion-card-content>
    </ion-card>
  }
</ion-content>
